<template>
    <div>
        <template v-if="hasExpression">
            <formula-expression v-bind:expression="childBinder.expression" />
        </template>
        <template v-else>
            <span class="mx-1 fst-italic"> Missing </span>
        </template>
    </div>
</template>
<script>
    export default {
        name: "ChildFormulaExpression",
        props: {
            childBinder: { type: Object, required: true }
        },
        computed: {
            hasExpression() {
                return this.childBinder.expression != null;
            }
        }
    };
</script>
